<template>
  <div class="importStaffStepTwo">
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Thêm {{ dataImportCurrent.length }} nhân viên<br /></h1>
      <p class="text-primary">{{ fileName }}</p>
      <div class="float-right">
        <router-link
          class="f12 font-medium btn btn-outline-secondary mr-1"
          :to="`/staff-import-step-one`"
          >Chọn lại</router-link
        >
      </div>
    </div>
    <!-- End Breadcrumb Area -->
    <div class="alert alert-warning alert-dismissible fade show" role="alert">
      <strong>Thông báo lỗi !</strong><br />Danh sách nhân viên không chính xác.
      <button type="button" class="close" data-dismiss="alert" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="card pt-15 b-t-1-869fb229">
      <div class="card-body">
        <div class="box-view">
          <div class="box-table table-responsive">
            <!-- <div class="box-header">
                            Số lượng : <strong class="text-primary">1000</strong>
                        </div> -->
            <table class="table table-hover table-bordered" id="tableScroll">
              <thead class="thead-light">
                <tr>
                  <th scope="col" class="text-center" width="50">STT</th>
                  <th scope="col">Tên</th>
                  <th scope="col">Mã nhân viên</th>
                  <th scope="col">Email</th>
                  <th scope="col">Số điện thoại</th>
                  <th scope="col">Ngày sinh</th>
                  <th scope="col">Địa chỉ</th>
                  <th scope="col">Giới tính</th>
                  <th scope="col">Vai trò</th>
                  <th scope="col">Quản lý</th>
                  <th scope="col">Vị trí</th>
                  <th scope="col">Ngày làm việc</th>
                  <th scope="col">Vùng KD</th>
                  <th scope="col">Tỉnh/ Thành phố</th>
                  <th scope="col">Leads/Ngày</th>
                  <th scope="col">Công việc/Ngày</th>
                  <th scope="col">KPI/Tháng</th>
                  <th scope="col">Cấp độ nhân viên</th>
                  <th scope="col">Ngày nghỉ việc</th>
                  <th scope="col">Chấm công</th>
                  <th scope="col">Ngày lên chính thức</th>
                  <th scope="col">Số CMND/CCCD/HC</th>
                  <th scope="col">Nơi cấp</th>
                  <th scope="col">Ngày cấp</th>
                  <th scope="col">Thời hạn HĐLĐ</th>
                  <th scope="col">Ngày ký HĐ gần nhất</th>
                  <th scope="col">Số phép dư</th>
                  <th scope="col">Ghi chú</th>
                </tr>
              </thead>
              <tbody v-for="(item, index) in dataImportCurrent" :key="index">
                <tr
                  v-bind:class="[
                    item.descriptionValidate !== ''
                      ? 'table-row bg-danger text-light'
                      : 'table-row',
                  ]"
                >
                  <td align="center">{{ index + 1 }}</td>
                  <td>
                    <b>{{ item.fullName }}</b>
                  </td>
                  <td>{{ item.code }}</td>
                  <td>{{ item.mail }}</td>
                  <td>{{ item.phone }}</td>
                  <td>{{ item.dateOfBirth | formatDate }}</td>
                  <td>{{ item.address }}</td>
                  <td>{{ item.gender }}</td>
                  <td>{{ item.role }}</td>
                  <td>{{ item.manager }}</td>
                  <td>{{ item.position }}</td>
                  <td>{{ item.dateJoinCompany | formatDate }}</td>
                  <td>{{ item.businessArea }}</td>
                  <td>{{ item.province }}</td>
                  <td>{{ item.lead_day }}</td>
                  <td>{{ item.work_day }}</td>
                  <td>{{ item.kpi_month }}</td>
                  <td>{{ item.level }}</td>
                  <td>{{ item.resign_date }}</td>
                  <td>{{ item.is_timekeep }}</td>
                  <td>{{ item.official_time }}</td>
                  <td>{{ item.identify_card }}</td>
                  <td>{{ item.place }}</td>
                  <td>{{ item.time_range | formatDate }}</td>
                  <td>{{ item.contract_period }}</td>
                  <td>{{ item.sign_contract_time | formatDate }}</td>
                  <td>{{ item.leave_day }}</td>
                  <td>{{ item.descriptionValidate }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  export default {
    data() {
      return {
        dataImportCurrent: [],
        dataErrCurrent: [],
      }
    },

    created() {
      this.dataImportCurrent = [...this.dataImport]
      console.log(this.dataImportCurrent)
      this.dataErrCurrent = [...this.dataErr]

      if (this.dataErrCurrent && this.dataErrCurrent.length > 0) {
        this.dataImportCurrent.map((elmDataImport, indexIP) => {
          this.dataErrCurrent.map((elmErr, indexER) => {
            if (elmErr.lineError === indexIP + 3) {
              elmDataImport.descriptionValidate = elmErr.message
            }
          })
        })
      }
    },

    computed: {
      ...mapGetters({
        dataImport: 'staff/getDataCacheTableRow',
        dataErr: 'staff/getDataCacheErrTableRow',
        fileName: 'staff/getDataFileNameExcel',
      }),
    },

    methods: {},
  }
</script>

<style scoped></style>
>
